import { useCallback, useEffect, useState } from 'react';
import { useBootstrapStatus } from '../hooks/useBootstrapStatus';
import { BootstrapForm } from '../components/BootstrapForm';
import { LoginForm } from '../components/LoginForm';
import { useMessageToast } from '../../shared/hooks/useMessageToast';
import { LanguageToggle } from '../../locale/components/LanguageToggle';
import layoutStyles from '../components/AuthLayout.module.css';
import primitives from '../../../styles/primitives.module.css';

export const LoginPage = ({ authForm, isChecking, t, locale, onLocaleChange }) => {
  const [showBootstrap, setShowBootstrap] = useState(false);
  const { status: bootstrapStatus, refreshStatus } = useBootstrapStatus({
    enabled: !isChecking,
    t,
  });

  useEffect(() => {
    if (bootstrapStatus.required) {
      setShowBootstrap(true);
    }
  }, [bootstrapStatus.required]);

  const handleBootstrapExit = useCallback(() => {
    setShowBootstrap(false);
  }, []);

  const handleBootstrapComplete = useCallback(() => {
    setShowBootstrap(false);
    refreshStatus();
  }, [refreshStatus]);

  useMessageToast(authForm.noticeMessage, 'success');
  useMessageToast(authForm.errorMessage, 'error');
  useMessageToast(bootstrapStatus.errorMessage, 'error');

  return (
    <div className={layoutStyles.shell}>
      <main className={layoutStyles.panel}>
        <header className={layoutStyles.header}>
          <div className={layoutStyles.intro}>
            <p className={primitives.eyebrow}>{t('appName')}</p>
            <h1>{t('accessTitle')}</h1>
            <p className={primitives.subtitle}>{t('accessSubtitle')}</p>
          </div>
        </header>

        {!isChecking ? (
          showBootstrap ? (
            <BootstrapForm
              onComplete={handleBootstrapComplete}
              onExit={handleBootstrapExit}
              t={t}
            />
          ) : (
            <>
              {bootstrapStatus.required ? (
                <div className={layoutStyles.callout}>
                  <p>{t('bootstrapRequiredNotice')}</p>
                  <button
                    className={primitives.ghostButton}
                    type="button"
                    onClick={() => setShowBootstrap(true)}
                  >
                    {t('bootstrapStart')}
                  </button>
                </div>
              ) : null}
              <LoginForm
                formState={authForm.formState}
                isSubmitting={authForm.isSubmitting}
                onChange={authForm.handleInputChange}
                onSubmit={authForm.handleSubmit}
                t={t}
              />
            </>
          )
        ) : null}

        <div className={layoutStyles.footer}>
          <LanguageToggle locale={locale} onChange={onLocaleChange} />
        </div>
      </main>
    </div>
  );
};
